import React from "react";
import { useTranslation } from "react-i18next";
import Block from "../../Block";
import FormGroup from "../../forms/FormGroup";
import FormRowCol from "../../forms/FormRowCol";
import Select from "../../forms/inputs/Select";

const formGroupWidthProps = {
  xs: 12,
  sm: 12,
  md: 12,
  lg: 8,
  xl: 6,
};

export default function Privacy({ getInputProps, formRefValues }) {
  const { t } = useTranslation();

  return (
    <Block title={t("dataVendor.privacy")}> 
      <FormGroup
        as={FormRowCol}
        {...formGroupWidthProps}
        label={t("dataVendor.cmp_vendor_id")}
        placeholder={t("pleaseSelect")}
        {...getInputProps("cmp_vendor_id")}
      >
        <Select isClearable={true}>
          {formRefValues.cmp_vendors.map((elt) => (
            <option value={elt.id} key={`cmp_vendor_id_${elt.id}`}>
              {elt.name}
            </option>
          ))}
        </Select>
      </FormGroup>
    </Block>
  );
}
